module.exports = __webpack_public_path__ + "media/images/app/visitors/bridal/hero-fc2f4b9994cae88d9c20ea222d57695b.webp";